import * as tslib_1 from "tslib";
import { ChangeDetectorRef, Component, ComponentFactoryResolver, ContentChild, DoCheck, ElementRef, EventEmitter, Inject, Input, KeyValueDiffer, KeyValueDiffers, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, Type, ViewChild, ViewContainerRef, } from '@angular/core';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { ComponentFactoryResult, JssComponentFactoryService } from '../jss-component-factory.service';
import { PlaceholderLoadingDirective } from './placeholder-loading.directive';
import { PLACEHOLDER_MISSING_COMPONENT_COMPONENT } from './placeholder.token';
import { RenderEachDirective } from './render-each.directive';
import { RenderEmptyDirective } from './render-empty.directive';
import { isRawRendering } from './rendering';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '../jss-component-factory.service';
import * as ɵngcc2 from '@angular/common';

const _c0 = ["view"];
function PlaceholderComponent_0_ng_template_0_Template(rf, ctx) { }
function PlaceholderComponent_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, PlaceholderComponent_0_ng_template_0_Template, 0, 0, "ng-template", 2);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.placeholderLoading == null ? null : ctx_r0.placeholderLoading.templateRef);
} }
function PlaceholderComponent_ng_template_1_Template(rf, ctx) { }
function getPlaceholder(rendering, name) {
    if (rendering && rendering.placeholders && Object.keys(rendering.placeholders).length > 0) {
        return rendering.placeholders[name];
    }
    return null;
}
let PlaceholderComponent = class PlaceholderComponent {
    constructor(componentFactoryResolver, differs, componentFactory, changeDetectorRef, elementRef, renderer, missingComponentComponent) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.differs = differs;
        this.componentFactory = componentFactory;
        this.changeDetectorRef = changeDetectorRef;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.missingComponentComponent = missingComponentComponent;
        this._componentInstances = [];
        this.destroyed = false;
        this.parentStyleAttribute = '';
        this.isLoading = true;
        this.loaded = new EventEmitter();
    }
    set inputs(value) {
        this._inputs = value;
        if (!this._differ && value) {
            this._differ = this.differs.find(value).create();
        }
    }
    ngOnInit() {
        // just to ensure the element exists
        const elem = this.elementRef.nativeElement;
        if (elem) {
            const attributes = elem.attributes;
            for (let i = 0; i < attributes.length; i++) {
                const attr = attributes.item(i);
                if (attr && attr.name.indexOf('_ngcontent') !== -1) {
                    this.parentStyleAttribute = attr.name;
                }
            }
        }
    }
    ngOnDestroy() {
        this.destroyed = true;
        this._componentInstances = [];
    }
    ngOnChanges(changes) {
        if (changes['rendering'] || changes['renderings']) {
            this._render();
        }
    }
    ngDoCheck() {
        if (!this._differ || !this._inputs || this._componentInstances.length === 0) {
            return;
        }
        const changes = this._differ.diff(this._inputs);
        if (!changes) {
            return;
        }
        const updates = {};
        changes.forEachRemovedItem((change) => updates[change.key] = null);
        changes.forEachAddedItem((change) => updates[change.key] = change.currentValue);
        changes.forEachChangedItem((change) => updates[change.key] = change.currentValue);
        this._componentInstances.forEach((componentInstance) => this._setComponentInputs(componentInstance, updates));
    }
    _setComponentInputs(componentInstance, inputs) {
        Object.entries(inputs).forEach(([input, inputValue]) => componentInstance[input] = inputValue);
    }
    _subscribeComponentOutputs(componentInstance, outputs) {
        Object.keys(outputs)
            .filter((output) => componentInstance[output] && componentInstance[output] instanceof Observable)
            .forEach((output) => componentInstance[output]
            .pipe(takeWhile(() => !this.destroyed))
            .subscribe(outputs[output]));
    }
    _render() {
        this._componentInstances = [];
        this.view.clear();
        if (!this.rendering && !this.renderings) {
            return;
        }
        if (!this.name && !this.renderings) {
            // tslint:disable-next-line:max-line-length
            console.warn(`Placeholder name was not specified, and explicit renderings array was not passed. Placeholder requires either name and rendering, or renderings.`);
            this.isLoading = false;
            return;
        }
        const placeholder = this.renderings || getPlaceholder(this.rendering, this.name || '');
        if (!placeholder) {
            console.warn(`Placeholder '${this.name}' was not found in the current rendering data`, JSON.stringify(this.rendering, null, 2));
            this.isLoading = false;
            return;
        }
        // if the placeholder is empty (contains only raw renderings), then we may need to use the empty template if it's defined
        const placeholderIsEmpty = placeholder.every((rendering) => isRawRendering(rendering));
        if (this.renderEmptyTemplate && placeholderIsEmpty) {
            this.view.createEmbeddedView(this.renderEmptyTemplate.templateRef, {
                renderings: placeholder,
            });
            this.isLoading = false;
        }
        else {
            this.componentFactory.getComponents(placeholder)
                .then((components) => components.forEach((rendering, index) => {
                if (this.renderEachTemplate && !isRawRendering(rendering.componentDefinition)) {
                    this._renderTemplatedComponent(rendering.componentDefinition, index);
                }
                else {
                    this._renderEmbeddedComponent(rendering, index);
                }
                this.isLoading = false;
            })).then(() => {
                this.changeDetectorRef.markForCheck();
                this.loaded.emit(this.name);
            });
        }
    }
    _renderTemplatedComponent(rendering, index) {
        // the render-each template takes care of all component mapping etc
        // generally using <sc-render-component> which is about like _renderEmbeddedComponent()
        // as a separate component
        this.view.createEmbeddedView(this.renderEachTemplate.templateRef, {
            rendering,
            index,
        });
    }
    _renderEmbeddedComponent(rendering, index) {
        if (!rendering.componentImplementation) {
            const componentName = rendering.componentDefinition.componentName;
            console.error(`Placeholder ${this.name} contains unknown component ${componentName}.`, `Ensure component is mapped, like:
        JssModule.withComponents([
          { name: '${componentName}', type: ${componentName}Component }
        ])`);
            rendering.componentImplementation = this.missingComponentComponent;
        }
        const componentFactory = rendering.componentFactory || this.componentFactoryResolver.resolveComponentFactory(rendering.componentImplementation);
        // apply the parent style attribute _ngcontent
        // work-around for https://github.com/angular/angular/issues/12215
        const createdComponentRef = this.view.createComponent(componentFactory, index);
        if (this.parentStyleAttribute) {
            this.renderer.setAttribute(createdComponentRef.location.nativeElement, this.parentStyleAttribute, '');
        }
        const componentInstance = createdComponentRef.instance;
        componentInstance.rendering = rendering.componentDefinition;
        if (this._inputs) {
            this._setComponentInputs(componentInstance, this._inputs);
        }
        if (this.outputs) {
            this._subscribeComponentOutputs(componentInstance, this.outputs);
        }
        this._componentInstances.push(componentInstance);
    }
};
PlaceholderComponent.ɵfac = function PlaceholderComponent_Factory(t) { return new (t || PlaceholderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.JssComponentFactoryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(PLACEHOLDER_MISSING_COMPONENT_COMPONENT)); };
PlaceholderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PlaceholderComponent, selectors: [["sc-placeholder"], ["", "sc-placeholder", ""]], contentQueries: function PlaceholderComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, RenderEachDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, RenderEmptyDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, PlaceholderLoadingDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.renderEachTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.renderEmptyTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.placeholderLoading = _t.first);
    } }, viewQuery: function PlaceholderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.view = _t.first);
    } }, inputs: { inputs: "inputs", name: "name", rendering: "rendering", renderings: "renderings", outputs: "outputs" }, outputs: { loaded: "loaded" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [[4, "ngIf"], ["view", ""], [3, "ngTemplateOutlet"]], template: function PlaceholderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PlaceholderComponent_0_Template, 1, 1, null, 0);
        ɵngcc0.ɵɵtemplate(1, PlaceholderComponent_ng_template_1_Template, 0, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLoading);
    } }, dependencies: [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet], encapsulation: 2 });
PlaceholderComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: KeyValueDiffers },
    { type: JssComponentFactoryService },
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: Renderer2 },
    { type: Type, decorators: [{ type: Inject, args: [PLACEHOLDER_MISSING_COMPONENT_COMPONENT,] }] }
];
tslib_1.__decorate([
    Input()
], PlaceholderComponent.prototype, "name", void 0);
tslib_1.__decorate([
    Input()
], PlaceholderComponent.prototype, "rendering", void 0);
tslib_1.__decorate([
    Input()
], PlaceholderComponent.prototype, "renderings", void 0);
tslib_1.__decorate([
    Input()
], PlaceholderComponent.prototype, "outputs", void 0);
tslib_1.__decorate([
    Output()
], PlaceholderComponent.prototype, "loaded", void 0);
tslib_1.__decorate([
    ViewChild('view', { read: ViewContainerRef, static: true })
], PlaceholderComponent.prototype, "view", void 0);
tslib_1.__decorate([
    ContentChild(RenderEachDirective, { static: true })
], PlaceholderComponent.prototype, "renderEachTemplate", void 0);
tslib_1.__decorate([
    ContentChild(RenderEmptyDirective, { static: true })
], PlaceholderComponent.prototype, "renderEmptyTemplate", void 0);
tslib_1.__decorate([
    ContentChild(PlaceholderLoadingDirective, { static: true })
], PlaceholderComponent.prototype, "placeholderLoading", void 0);
tslib_1.__decorate([
    Input()
], PlaceholderComponent.prototype, "inputs", null);
PlaceholderComponent = tslib_1.__decorate([ tslib_1.__param(6, Inject(PLACEHOLDER_MISSING_COMPONENT_COMPONENT))
], PlaceholderComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PlaceholderComponent, [{
        type: Component,
        args: [{
                selector: 'sc-placeholder,[sc-placeholder]',
                template: `
    <ng-template *ngIf="isLoading" [ngTemplateOutlet]="placeholderLoading?.templateRef"></ng-template>
    <ng-template #view></ng-template>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.KeyValueDiffers }, { type: ɵngcc1.JssComponentFactoryService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.Type, decorators: [{
                type: Inject,
                args: [PLACEHOLDER_MISSING_COMPONENT_COMPONENT]
            }] }]; }, { loaded: [{
            type: Output
        }], inputs: [{
            type: Input
        }], name: [{
            type: Input
        }], rendering: [{
            type: Input
        }], renderings: [{
            type: Input
        }], outputs: [{
            type: Input
        }], view: [{
            type: ViewChild,
            args: ['view', { read: ViewContainerRef, static: true }]
        }], renderEachTemplate: [{
            type: ContentChild,
            args: [RenderEachDirective, { static: true }]
        }], renderEmptyTemplate: [{
            type: ContentChild,
            args: [RenderEmptyDirective, { static: true }]
        }], placeholderLoading: [{
            type: ContentChild,
            args: [PlaceholderLoadingDirective, { static: true }]
        }] }); })();
export { PlaceholderComponent };
